<template lang="pug">
  .component-client-action-buttons
    ul.dropdown.menu(data-dropdown-menu='', v-f="")
      li
        a(href='#Item-1') Action
        ul.menu
          li
            a(v-on:click="edit") Edit
</template>
<script type="text/babel">
import MaggieHelper from "src/maggieHelper";
import PlanSmartEdit from "../../../backoffice/smartedits/PlanEdit";
import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";

export default {
  name: "PlanActionButtons",
  components: {
    plan: null,
  },
  data() {
    return {
      tocs: {}
    }
  },
  created() {
    KeplerBackofficeSdk.plans.select(this.$route.params.id).get((item) => {
      this.entity = item
    })

    KeplerBackofficeSdk.tocs.list.all((data) => {
      data.forEach((item) => {
        this.tocs[item.id] = item.name
      })
    })
  },
  methods: {
    edit() {
      MaggieHelper.openRightPanel({
        component: PlanSmartEdit, props: {
          item: this.entity,
          tocs:this.tocs
        }
      })
    }
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// PlanActionButtons.vue?30a316fa